import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DrilldownHeader } from '@components/DrilldownHeader';

import { LEGAL } from '@constants/routes';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import LegalSurvey from './LegalSurvey';

const messages = defineMessages({
  title: {
    id: 'heroicMeasures.title',
    defaultMessage: 'Heroic Measures',
  },
  subtitle: {
    id: 'heroicMeasures.subtitle',
    defaultMessage: 'What heroic measures do you accept to preserve your life?',
  },
});

const HeroicMeasures: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <AppLayout friendlyName={formatMessage(messages.title)}>
      <DrilldownHeader
        backRoute={LEGAL}
        subtitle={formatMessage(messages.subtitle)}
        title={formatMessage(messages.title)}
      />
      <MainContainer maxWidth="600px">
        <LegalSurvey questionId="heroic-measures" />
      </MainContainer>
    </AppLayout>
  );
};

export default HeroicMeasures;
